module.exports = __webpack_public_path__ + "static/media/galerija_2016 (15).9635d29e.jpg";